import { Injectable, inject } from '@angular/core';
import { dsApi, dsDtos } from '@vectronic/openApi-customer';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnimalSpeciesRestService {
  private animalSpeciesApi = inject(dsApi.AnimalSpeciesCustomers);

  fetchAnimalSpecies(): Observable<dsDtos.AnimalSpecies[]> {
    return this.animalSpeciesApi.get();
  }
}
